module.exports = __webpack_public_path__ + "static/media/remixicon.7eafaf2d.woff";